import { useState } from 'react';
import { yupToFormErrors } from 'formik';
import * as Yup from 'yup';
import { useOrderStore } from 'store/orderStore';
import { useCampaignStore } from 'store/campaignStore';
import { useBidRange } from './useBidRange';
import { getBasicValidationSchema } from './validationSchemas';

interface initialShopForm {
  defaultForm: any;
  values: any;
}

const useShopFormValidation = (
  initialState: initialShopForm = { defaultForm: {}, values: {} },
) => {
  const { defaultForm, values } = initialState;
  const { order } = useOrderStore();
  const { actionType } = useCampaignStore();
  const bidRange = useBidRange();
  const [errors, setErrors] = useState<any>({ basic: {}, products: '' });

  // 基本欄位通用驗證（僅取 budget, dailyTargetBudget, bidPrice, startDate, endDate）
  const commonSchema = getBasicValidationSchema({
    defaultForm,
    actionType,
    order,
    bidRange,
  }).pick([
    'name',
    'budget',
    'dailyTargetBudget',
    'bidPrice',
    'startDate',
    'endDate',
  ]);

  const shopBasicSchema = Yup.object()
    .shape({
      webBrandNo: Yup.string().required('請選擇品牌'),
    })
    .concat(commonSchema);

  const validationSchema = Yup.object().shape({
    basic: shopBasicSchema,
  });
  const handleValidation = () => {
    validationSchema
      .validate(values, { abortEarly: false })
      .then(() => setErrors({}))
      .catch((err) => {
        setErrors(yupToFormErrors(err));
      });
  };

  return { validationSchema, errors, setErrors, handleValidation };
};

export default useShopFormValidation;
